import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Layout,
  Card,
  Input,
  Button,
  Table,
  InputNumber,
  Typography,
  Space,
  Row,
  Col,
  Divider,
  Badge,
  message,
  Modal,
  Tabs,
  Drawer,
  Switch,
  Checkbox,
  Spin
} from 'antd';
import {
  ShoppingCartOutlined,
  DeleteOutlined,
  PlusOutlined,
  MinusOutlined,
  FileTextOutlined,
  ClearOutlined,
  AppstoreOutlined,
  CalculatorOutlined,
  SaveOutlined,
  FolderOutlined,
  DollarOutlined,
  MenuOutlined,
  BookOutlined,
  CheckOutlined, 
  WarningOutlined
} from '@ant-design/icons';
import axios from 'axios';
// Importar los componentes modales
import CatalogoModal from './ModalInsumos/ModalInsumos';
import ModalPago from './ModalPago/ModalPago';
import SelectClientesItem from '../../Components/SelectClientesItem';
import ModalCorteCaja from './CorteCaja/CorteCaja';
import round6Decimals from '../../Components/round6Decimals';
import round2Decimals from '../../Components/round2Decimals';
import ModalRetiroCaja from './RetiroEfectivo/RetiroEfectivo';
import { ButtonItem, dineroDisabledMask, TextAreaItem } from '../../Components/Items';
import ElegirTipoDeCliente from '../Panel/Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente';
import ModalIngresoCaja from './IngresoEfectivo/IngresoEfectivo';
import qz from 'qz-tray';
import ModalElegirImpresora from './ModalElegirImpresora/ModalElegirImpresora';
import IconCurrencyDollar from '../../Icons/IconCurrencyDollar';
import ModalCobrarVenta from './ModalCobrarVenta/ModalCobrarVenta';
import ModalFacturarVenta from './ModalFacturarVenta/ModalFacturarVenta';
import ModalGenerarFactura from './ModalGenerarFactura/ModalGenerarFactura';
import ModalVentasPendientes from './ModalVentasPendientes/ModalVentasPendientes';
import ElegirLotes from '../Panel/LotesCaducidades/ElegirLotes/ElegirLotes';

const { Content, Sider } = Layout;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

// Estado inicial para una venta
const initialSaleState = {
  cart: [],
  customer: '',
  barcodeInput: '',
  discount: 0,
  clienteSeleccionadoId: null,
  cartCalculations: {},
  totalCalculations: null,
  factura: false,
  observaciones: '',
  imprimirObservaciones: true,
  totalBreakdown: {
    subtotal: 0,
    totalImpuestos: 0,
    totalRetenciones: 0,
    arrayImpuestos: [],
    arrayRetenciones: [],
    total: 0,
    totalPagar: 0
  }
};

// Estado inicial del componente
const initialState = {
  products: [],
  showPaymentModal: false,
  cobroVenta: false,
  totalPagarCobroVenta: 0,
  ventaIdParaCobro: null,
  ventaIdParaFacturar: null,
  numeroVentaFacturar: null,
  showProductModal: false,
  showCorteCajaModal: false,
  modalRetiroCaja: false,
  modalIngresoCaja: false,
  showDrawerMenu: false,
  puntoVentaActivo: true,
  cajaNombre: '',
  montoGeneral: 0,
  empresaId: null,
  precioId: null,
  todasClientes: [], // Datos completos de clientes para cálculo de retenciones
  clienteId: null,
  proyectoId: null,
  productosParaTicket: [],
  bancoId: null,
  formaDePagoId: null,
  arrayImpuestosVenta: [],

  tipoDeCambio: 1,
  // Nuevo estado para las pestañas
  savedSales: [], // Array de ventas guardadas
  activeTab: 'current', // Pestaña activa
  currentSale: { ...initialSaleState }, // Venta actual
  tabCounter: 1, // Contador para generar IDs únicos de pestañas
  modalElegirTipoDeCliente: false,
  modalElegirTipoDeClienteId: null,
  modalElegirTipoDeClienteNombre: null,
  impresoraSeleccionada: null,
  modalElegirImpresora: false,
  modalCobrarVenta: false,
  modalFacturarVenta: false,
  recargarVentas: false,
  numeroVentaCobrar: null,
  listaClienteActiva: false,
  listaDePrecios : [], 
  // Modal lotes 
  modalElegirLotes: false,
  modalElegirLotesId: null,
  modalElegirLotesLotes: [],
  modalElegirLotesInsumoId: null,
  modalElegirLotesCantidad: null,
};

class PuntoDeVentaPag extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.consultarInfoSesion()

    // Mantener sesión activa cada 5 minutos
    this.keepAliveInterval = setInterval(() => {
      this.pingSesion(); // puedes usar una consulta ligera o HEAD
    }, 5 * 60 * 1000); // 5 minutos

    window.addEventListener('keydown', this.handleGlobalKeyDown);

    qz.security.setCertificatePromise(function (resolve, reject) {
      //Preferred method - from server
      fetch("../cert_qz_tray.txt", { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
        .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });
    })

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        // Preferred method - from server

        // axios.post('/puntoVenta/signQzTray', toSign, {
        //   headers: {
        //     ...this.props.headersToken,
        //     'Content-Type': 'text/plain',
        //   }
        // })
        //   .then(response => {
        //     console.log("Firma recibida:", response.data);
        //     resolve(response.data); // ✔️ Texto plano (la firma base64)
        //   })
        //   .catch(error => {
        //     console.error('Error firmando para QZ Tray:', error);
        //     reject("No se pudo firmar el contenido");
        //   });

        fetch("../erp/api/puntoVenta/signQzTray?request=" + toSign, { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
          .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });

        //Alternate method - unsigned
        // resolve(); // remove this line in live environment
      };
    });

    // qz.security.setCertificatePromise(() => {
    //   // Devuelve el certificado (en formato PEM)
    //   return axios.get('/puntoVenta/certQzTray', {
    //     headers: this.props.headersToken,
    //   }).then(res => {
    //     console.log("Certificado recibido:", res.data);
    //     return res.data;
    //   });
    // });

    // qz.security.setSignaturePromise(async (toSign) => {
    //   console.log("Firmando con QZ Tray:", toSign);
    //   try {
    //     const response = axios.post('puntoVenta/signQzTray', toSign, {
    //       headers: {
    //         ...this.props.headersToken,
    //         'Content-Type': 'text/plain',
    //       }
    //     });

    //     return response.data; // ✔️ Texto plano (la firma base64)
    //   } catch (err) {
    //     console.error('Error firmando para QZ Tray:', err);
    //     throw new Error("No se pudo firmar el contenido");
    //   }
    // });

    if (!this.state.impresoraSeleccionada) {
      this.setState({ modalElegirImpresora: true });
    }

  }

  pingSesion = () => {
    axios.post(
      "sesionesPV/pingSesion",
      { sesionId: this.props.match.params.id },
      { headers: this.props.headersToken }
    )
      .then(res => {
        if (res.data.success !== 2) {
          message.error("Error al mantener la sesión activa");
        }
      })
      .catch(error => {
        console.error("Error al mantener la sesión activa:", error);
        message.error("Error al mantener la sesión activa");
      });
  };

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleGlobalKeyDown);
  }

  handleGlobalKeyDown = (event) => {
    if (!this.state.modalElegirImpresora && !this.state.modalRetiroCaja && !this.state.modalIngresoCaja && !this.state.showPaymentModal && !this.state.showProductModal && !this.state.showCorteCajaModal && !this.state.showDrawerMenu) {
      if (event.key === "F2" && this.state.currentSale.clienteSeleccionadoId && this.getCurrentCart().length !== 0) {
        // this.processPayment();
      }
      if (event.key === "F4") {
        // this.setState({ showProductModal: true });
      }
      if (event.key === "F8") {
        // this.saveCurrentSale();
      }
    }
  }

  abrirDrawerMenu = () => {
    this.setState({ showDrawerMenu: true });
  };

  cerrarDrawerMenu = () => {
    this.setState({ showDrawerMenu: false });
  };

  consultarInfoSesion() {
    this.setState({ loading: true });
    return axios
      .post(
        "sesionesPV/datosSesionesPV",
        { sesionId: this.props.match.params.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data.sesion.fechaFinal) {
            this.setState({ showCorteCajaModal: false, puntoVentaActivo: false })
            message.warning("Esta sesion ya fue cerrada, no se puede realizar mas ventas");
          } else {
            this.setState({
              cajaNombre: res.data.sesion.cajaNombre,
              montoGeneral: res.data.sesion.montoGeneral,
              empresaId: res.data.sesion.empresaId,
              precioId: res.data.sesion.precioId,
              clienteId: res.data.sesion.clienteId || null,
              proyectoId: res.data.sesion.proyectoId || null,
              bancoId: res.data.sesion.bancoEfectivo || null,
              formaDePagoId: res.data.sesion.formaDePagoId || null,
              listaClienteActiva: res.data.sesion.listaCliente || false,
              listasDePrecios: res.data.sesion.preciosEmpresa || [],
              currentSale: {
                ...this.state.currentSale,
                clienteSeleccionadoId: res.data.sesion.clienteId || null,
              },
            });
          }
        } else if (res.data.success === 1) {
          this.setState({ showCorteCajaModal: false, puntoVentaActivo: false })
          message.error(res.data.message ? res.data.message : "No se encontro informacion");
        } else {
          this.setState({ showCorteCajaModal: false, puntoVentaActivo: false })
          message.error("No se encontro informacion");
        }
        this.setState({ loading: false });
      });
  }

  abrirRetiroCaja = () => {
    this.setState({ modalRetiroCaja: true, showDrawerMenu: false });
  };

  abrirIngresoCaja = () => {
    this.setState({ modalIngresoCaja: true, showDrawerMenu: false });
  };


  getPrecioIdDinamico = (clienteIdForzado = null) => {
    const currentSale = this.getCurrentSale();
    const idBuscar = clienteIdForzado || currentSale.clienteSeleccionadoId;
    
    const cliente = this.state.todasClientes.find(c => c._id === idBuscar);

    if (this.state.listaClienteActiva && cliente?.precioContadoId) {
      return cliente.precioContadoId;
    }
    return this.state.precioId || this.props.precioId;
  };

  obtenerPrecioPorId = (insumo) => {
    const precioIdAplicar = this.getPrecioIdDinamico();

    if (!precioIdAplicar) {
      return insumo.precios && insumo.precios.length > 0
        ? insumo.precios[0].precio
        : insumo.costo;
    }

    const precioEncontrado = insumo.precios && insumo.precios.find(
      precio => precio.precioId === precioIdAplicar
    );

    return precioEncontrado ? precioEncontrado.precio : insumo.costo;
  };

  obtenerNombreListaActual = () => {
    const precioIdActivo = this.getPrecioIdDinamico();
    if (!precioIdActivo) return "General"; 

    const listaEncontrada = this.state.listasDePrecios.find(p => p._id === precioIdActivo);
    
    return listaEncontrada ? listaEncontrada.nombre : "Cliente";
  };

  getCurrentCart = () => {
    if (this.state.activeTab === 'current') {
      return this.state.currentSale.cart;
    } else {
      const savedSale = this.state.savedSales.find(sale => sale.id === this.state.activeTab);
      return savedSale ? savedSale.cart : [];
    }
  };

  getCurrentSale = () => {
    if (this.state.activeTab === 'current') {
      return this.state.currentSale;
    } else {
      const savedSale = this.state.savedSales.find(sale => sale.id === this.state.activeTab);
      return savedSale || { ...initialSaleState };
    }
  };

  updateCurrentSale = (updates) => {
    if (this.state.activeTab === 'current') {
      this.setState({
        currentSale: { ...this.state.currentSale, ...updates }
      });
    } else {
      const updatedSales = this.state.savedSales.map(sale =>
        sale.id === this.state.activeTab
          ? { ...sale, ...updates }
          : sale
      );
      this.setState({ savedSales: updatedSales });
    }
  };

  // Función corregida calcularImpuestosYRetenciones
  // Función corregida para calcular impuestos y retenciones
  calcularImpuestosYRetenciones = (insumo, quantity, discount = 0) => {
    const { tipoDeCambio } = this.state;
    const currentSale = this.getCurrentSale();
    const clienteSeleccionado = this.state.todasClientes.find(
      cliente => cliente._id === currentSale.clienteSeleccionadoId
    );

    const precioUnitario = Number(insumo.price);
    const cantidad = Number(quantity);
    const descuentoPorcentaje = Number(discount);

    // 1. Calcular subtotal
    const subtotal = round6Decimals(cantidad * precioUnitario);

    // 2. Calcular descuento
    const totalDescuento = round6Decimals(subtotal * (descuentoPorcentaje / 100));

    // 3. Total después del descuento
    const totalEntrada = round6Decimals(subtotal - totalDescuento);

    // 4. Calcular impuestos
    let totalImpuestos = 0;
    let arrayImpuestos = [];

    // Verificar si el insumo tiene impuestos
    if (insumo.insumoOriginal.impuestos && insumo.insumoOriginal.impuestos.length > 0) {
      insumo.insumoOriginal.impuestos.forEach((impuesto) => {
        let totalImpuesto = 0;
        let baseImpuesto = 0;
        let montoImpuesto = 0;

        if (impuesto.tasaCuota === 1) {
          // Tasa por porcentaje sobre el valor
          totalImpuesto = round6Decimals(totalEntrada * (impuesto.monto / 100));
          baseImpuesto = totalEntrada;
          montoImpuesto = round6Decimals(impuesto.monto / 100);
        } else if (impuesto.tasaCuota === 2) {
          // Tasa por porcentaje sobre el valor más otros impuestos trasladados
          const baseCalculo = totalEntrada + totalImpuestos;
          totalImpuesto = round6Decimals(baseCalculo * (impuesto.monto / 100));
          baseImpuesto = baseCalculo;
          montoImpuesto = round6Decimals(impuesto.monto / 100);
        } else if (impuesto.tasaCuota === 3) {
          // Cuota por unidad
          totalImpuesto = round6Decimals((cantidad * impuesto.monto) / tipoDeCambio);
          baseImpuesto = cantidad;
          montoImpuesto = round6Decimals(impuesto.monto / tipoDeCambio);
        } else if (impuesto.tasaCuota === 5) {
          // Exento
          totalImpuesto = 0;
          baseImpuesto = totalEntrada;
          montoImpuesto = 0;
        }

        totalImpuestos += totalImpuesto;

        arrayImpuestos.push({
          tasaCuota: impuesto.tasaCuota,
          impuesto: impuesto.impuesto,
          montoImpuesto: montoImpuesto,
          local: impuesto.local,
          baseImpuesto: baseImpuesto,
          descripcionFactura: impuesto.descripcionFactura,
          totalImpuestos: totalImpuesto,
        });
      });
    }

    // 5. Calcular retenciones
    let totalRetenciones = 0;
    let arrayRetenciones = [];

    if (clienteSeleccionado) {
      // Retenciones del cliente
      if (clienteSeleccionado.retenciones && clienteSeleccionado.retenciones.length > 0) {
        clienteSeleccionado.retenciones.forEach((retencion) => {
          let totalRetencion = 0;
          let baseRetencion = 0;

          if (retencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (retencion.monto / 100));
            baseRetencion = totalEntrada;
          } else if (retencion.tasaCuota === 2) {
            // Para retenciones, generalmente la base es totalEntrada + totalImpuestos
            totalRetencion = round6Decimals((totalEntrada + totalImpuestos) * (retencion.monto / 100));
            baseRetencion = (totalEntrada + totalImpuestos);
          }

          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            tasaCuota: retencion.tasaCuota,
            impuesto: retencion.impuesto,
            montoRetencion: retencion.monto,
            local: retencion.local,
            baseRetencion: baseRetencion,
            descripcionFactura: retencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
        });
      }

      // Retenciones del insumo
      if (insumo.retenciones && insumo.retenciones.length > 0) {
        insumo.retenciones.forEach((retencion) => {
          if ((retencion.aplicaVenta === 1 && clienteSeleccionado.persona === false) ||
            (retencion.aplicaVenta === 2 && clienteSeleccionado.persona === true) ||
            retencion.aplicaVenta === 3) {

            let totalRetencion = 0;
            let baseRetencion = 0;

            if (retencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (retencion.monto / 100));
              baseRetencion = totalEntrada;
            } else if (retencion.tasaCuota === 2) {
              totalRetencion = round6Decimals((totalEntrada + totalImpuestos) * (retencion.monto / 100));
              baseRetencion = (totalEntrada + totalImpuestos);
            }

            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              tasaCuota: retencion.tasaCuota,
              impuesto: retencion.impuesto,
              montoRetencion: retencion.monto,
              local: retencion.local,
              baseRetencion: baseRetencion,
              descripcionFactura: retencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
        });
      }
    }

    return {
      subtotal: totalEntrada,
      totalImpuestos: round2Decimals(totalImpuestos),
      totalRetenciones: round2Decimals(totalRetenciones),
      arrayImpuestos,
      arrayRetenciones,
      total: round2Decimals(totalEntrada + totalImpuestos)
    };
  };

  addProductByBarcode = () => {
    const currentSale = this.getCurrentSale();
    const barcode = currentSale.barcodeInput.trim();
    if (!barcode) return;

    axios.post(
      "puntoVenta/obtenerInsumoPorCodigo",
      {
        codigoBarras: barcode,
        proyectoId: this.state.proyectoId,
        empresaId: this.state.empresaId
      },
      { headers: this.props.headersToken }
    )
      .then(res => {
        if (res.data && res.data.success === 2 && res.data.insumo) {
          const insumo = res.data.insumo;
          const product = {
            id: insumo.codigo,
            name: insumo.descripcion,
            price: this.obtenerPrecioPorId(insumo),
            category: insumo.categoria || 'Sin categoría',
            stock: insumo.cantidad || 0,
            barcode: insumo.codigoBarras || 'N/A',
            impuestos: insumo.impuestos || [],
            retenciones: insumo.retenciones || [],
            insumoOriginal: insumo // Agregar el insumo original completo
          };
          this.addToCart(product);
          message.success(`Producto "${product.name}" agregado al carrito`);
        } else {
          message.error('Producto no encontrado');
        }
        this.updateCurrentSale({ barcodeInput: '' });
      })
      .catch(error => {
        console.error("Error al buscar insumo:", error);
        message.error('Error al buscar producto');
        this.updateCurrentSale({ barcodeInput: '' });
      });
  };

  handleBarcodeInput = (e) => {
    if (e.key === 'Enter') {
      this.addProductByBarcode();
    }
  };

  addToCart = (product) => {
    const cart = this.getCurrentCart();
    const currentSale = this.getCurrentSale();
    const existingItem = cart.find(item => item.id === product.id);
    let newCart;

    if (existingItem && (existingItem.quantity < product.stock || !product.inventariable)) {
      newCart = cart.map(item => {
        if (item.id === product.id) {
          const newQuantity = item.quantity + 1;
          const calculoImpuestos = this.calcularImpuestosYRetenciones(item, newQuantity, currentSale.discount || 0);
          return {
            ...item,
            quantity: newQuantity,
            subtotal: calculoImpuestos.subtotal,
            totalImpuestos: calculoImpuestos.totalImpuestos,
            totalRetenciones: calculoImpuestos.totalRetenciones,
            total: calculoImpuestos.total
          };
        }
        return item;
      });
    } else if (!existingItem) {
      const calculoImpuestos = this.calcularImpuestosYRetenciones(product, 1, currentSale.discount || 0);
      newCart = [...cart, {
        ...product,
        quantity: 1,
        lotes: [], 
        insumoOriginal: product.insumoOriginal || product,
        subtotal: calculoImpuestos.subtotal,
        totalImpuestos: calculoImpuestos.totalImpuestos,
        totalRetenciones: calculoImpuestos.totalRetenciones,
        total: calculoImpuestos.total
      }];
    } else {
      message.warning('No hay suficiente stock disponible');
      return;
    }

    // Actualizar el carrito
    this.updateCurrentSale({
      cart: newCart,
      totalCalculations: null,
      cartCalculations: {}
    });

    // Forzar recálculo completo después de un micro-delay
    setTimeout(() => {
      this.calculateTotalPagar();
    }, 10);
  };

  updateQuantity = (id, newQuantity) => {
    if (newQuantity <= 0) {
      this.removeFromCart(id);
      return;
    }

    const product = this.state.products.find(p => p.id === id);
    if (product && newQuantity > product.stock) {
      message.warning('Cantidad excede el stock disponible');
      return;
    }

    const cart = this.getCurrentCart();
    const currentSale = this.getCurrentSale();
    const updatedCart = cart.map(item => {
      if (item.id === id) {
        const calculoImpuestos = this.calcularImpuestosYRetenciones(item, newQuantity, currentSale.discount || 0);
        return {
          ...item,
          quantity: newQuantity,
          subtotal: calculoImpuestos.subtotal,
          totalImpuestos: calculoImpuestos.totalImpuestos,
          totalRetenciones: calculoImpuestos.totalRetenciones,
          total: calculoImpuestos.total
        };
      }
      return item;
    });

    // Limpiar cache y actualizar carrito
    this.updateCurrentSale({
      cart: updatedCart,
      cartCalculations: {},
      totalCalculations: null
    });

    // Forzar recálculo completo
    setTimeout(() => {
      this.calculateTotalPagar();
    }, 10);
  };

  calculateTotalPagar = () => {
    const cart = this.getCurrentCart();
    const currentSale = this.getCurrentSale();
    const discount = currentSale.discount || 0;
    const clienteId = currentSale.clienteSeleccionadoId;

    // Verificar si tenemos el total cacheado
    const totalKey = `totalPagar_${cart.length}_${discount}_${clienteId}_${cart.map(item => `${item.id}:${item.quantity}`).join('|')}`;

    // if (currentSale.totalCalculations && currentSale.totalCalculations.key === totalKey) {
    //   return currentSale.totalCalculations.totalPagar;
    // }

    let totalTotal = 0;
    let totalPagarGeneral = 0;
    let totalSubtotal = 0;
    let totalImpuestos = 0;
    let totalRetenciones = 0;

    cart.forEach(item => {
      const cachedCalculation = this.getProductCalculationFromCache(item.id, item.quantity, discount, clienteId);

      let calculation;
      if (cachedCalculation) {
        calculation = cachedCalculation;
      } else {
        calculation = this.calculateAndCacheProductTaxes(item, item.quantity, discount, clienteId);
      }

      totalTotal += round2Decimals(calculation.total);
      totalSubtotal += round2Decimals(calculation.subtotal);
      totalImpuestos += round2Decimals(calculation.totalImpuestos);
      totalRetenciones += round2Decimals(calculation.totalRetenciones);
    });

    // Cachear el total con desglose
    const newTotalCalculations = {
      key: totalKey,
      total: round2Decimals(totalTotal),
      totalPagar: round2Decimals(totalTotal - totalRetenciones),
      timestamp: Date.now()
    };

    const newTotalBreakdown = {
      subtotal: round2Decimals(totalSubtotal),
      totalImpuestos: round2Decimals(totalImpuestos),
      totalRetenciones: round2Decimals(totalRetenciones),
      total: round2Decimals(totalTotal),
      totalPagar: round2Decimals(totalTotal - totalRetenciones),
    };

    this.updateCurrentSale({
      totalCalculations: newTotalCalculations,
      totalBreakdown: newTotalBreakdown
    });

    return totalPagarGeneral;
  };

  removeFromCart = (id) => {
    const cart = this.getCurrentCart();
    const updatedCart = cart.filter(item => item.id !== id);

    this.updateCurrentSale({
      cart: updatedCart,
      totalCalculations: null,
      cartCalculations: {} // Limpiar también el cache de productos
    });

    // Forzar recálculo si aún hay productos
    if (updatedCart.length > 0) {
      setTimeout(() => {
        this.calculateTotalPagar();
      }, 10);
    }
  };

  clearCart = () => {
    this.updateCurrentSale({
      cart: [],
      customer: '',
      factura: false,
      observaciones: '',
      imprimirObservaciones: true,
      barcodeInput: '',
      discount: 0,
      clienteSeleccionadoId: this.state?.clienteId || null,
      totalBreakdown: {
        subtotal: 0,
        totalImpuestos: 0,
        totalRetenciones: 0,
        total: 0,
        totalPagar: 0,
        arrayImpuestos: [],
        arrayRetenciones: [],
      }
    });
  };

  // Nueva función para guardar venta
  saveCurrentSale = () => {
    const currentSale = this.getCurrentSale();

    if (currentSale.cart.length === 0) {
      message.warning('No hay productos en el carrito para guardar');
      return;
    }

    const saleId = `sale_${this.state.tabCounter}`;
    const customerName = currentSale.customer || 'Sin cliente';
    const itemCount = currentSale.cart.length;

    let customerFinal = currentSale.customer;

    if (!customerFinal) {
      const clienteSeleccionado = this.state.todasClientes.find(i => i._id === this.state.clienteId);
      customerFinal = clienteSeleccionado ? clienteSeleccionado.stringBuscar : 'Sin cliente';
    }

    const savedSale = {
      id: saleId,
      name: `${customerName} (${itemCount} items)`,
      timestamp: new Date().toLocaleString(),
      cart: [...currentSale.cart],
      customer: customerFinal,
      factura: currentSale.factura,
      observaciones: currentSale.observaciones,
      imprimirObservaciones: currentSale.imprimirObservaciones,
      discount: currentSale.discount,
      clienteSeleccionadoId: currentSale.clienteSeleccionadoId,
      cartCalculations: currentSale.cartCalculations,
      totalCalculations: currentSale.totalCalculations,
      totalBreakdown: currentSale.totalBreakdown,
      barcodeInput: '',
    };

    const clienteEncontrado = this.state.todasClientes.find(i => i._id === this.state.clienteId);

    this.setState({
      savedSales: [...this.state.savedSales, savedSale],
      tabCounter: this.state.tabCounter + 1,
      currentSale: {
        ...initialSaleState,
        clienteSeleccionadoId: this.state.clienteId || null, // Mantener el cliente seleccionado
        customer: clienteEncontrado ? clienteEncontrado.stringBuscar : '',
      },
      activeTab: 'current'
    });

    message.success('Venta guardada exitosamente');
  };

  // Función para eliminar una venta guardada
  removeSavedSale = (saleId) => {
    const updatedSales = this.state.savedSales.filter(sale => sale.id !== saleId);
    this.setState({
      savedSales: updatedSales,
      activeTab: 'current'
    });
  };

  // Función para cambiar de pestaña
  onTabChange = (activeKey) => {
    this.setState({ activeTab: activeKey });

    // Limpiar cache al cambiar de pestaña para asegurar cálculos frescos
    if (activeKey !== this.state.activeTab) {
      this.clearCalculationCache();
    }
  };

  processPayment = () => {
    const cart = this.getCurrentCart();
    const currentSale = this.getCurrentSale();

    if (currentSale.clienteSeleccionadoId === null) {
      message.warning('Por favor, seleccione un cliente antes de continuar');
      return;
    }

    if (cart.length === 0) {
      message.warning('El carrito está vacío');
      return;
    }

    const insumos = cart.map(item => {
      const discount = currentSale.discount || 0;
      const calculoImpuestos = this.calcularImpuestosYRetenciones(item, item.quantity, discount);

      const montoSinIva = round2Decimals(item.price);
      const impuestosCalculados = calculoImpuestos.totalImpuestos;
      const precioUnitarioConImpuestos = round2Decimals(montoSinIva + impuestosCalculados);

      return {
        proyectoId: this.state.proyectoId,
        descuento: discount,
        insumoId: item.insumoOriginal._id || item.id, // Asegúrate que `_id` exista
        lotes: item.lotes || [],
        precioUnitario: montoSinIva,
        precioUnitarioConImpuestos: precioUnitarioConImpuestos,
        cantidad: item.quantity,
        subtotal: calculoImpuestos.subtotal,
        impuestos: calculoImpuestos.totalImpuestos,
        arrayImpuestos: calculoImpuestos.arrayImpuestos,
        total: calculoImpuestos.total,
        retenciones: calculoImpuestos.totalRetenciones,
        arrayRetenciones: calculoImpuestos.arrayRetenciones,
      };
    });

    const arrayImpuestosGlobal = [];
    const arrayRetencionesGlobal = [];
    let cuentasCliente = 0

    insumos.forEach(insumo => {
      insumo.arrayImpuestos.forEach(imp => {
        const idx = arrayImpuestosGlobal.findIndex(ai =>
          ai.tasaCuota === imp.tasaCuota &&
          ai.impuesto === imp.impuesto &&
          ai.descripcionFactura === imp.descripcionFactura
        );

        if (idx > -1) {
          arrayImpuestosGlobal[idx].totalImpuestos = round2Decimals(arrayImpuestosGlobal[idx].totalImpuestos + imp.totalImpuestos);
          arrayImpuestosGlobal[idx].baseImpuesto = round2Decimals(arrayImpuestosGlobal[idx].baseImpuesto + imp.baseImpuesto);
        } else {
          arrayImpuestosGlobal.push({
            tasaCuota: imp.tasaCuota,
            impuesto: imp.impuesto,
            montoImpuesto: imp.montoImpuesto,
            baseImpuesto: imp.baseImpuesto,
            descripcionFactura: imp.descripcionFactura,
            totalImpuestos: imp.totalImpuestos,
          });
        }
      });
      if (insumo.arrayRetenciones && insumo.arrayRetenciones.length > 0) {
        insumo.arrayRetenciones.forEach(ret => {
          const idx = arrayRetencionesGlobal.findIndex(ar =>
            ar.tasaCuota === ret.tasaCuota &&
            ar.impuesto === ret.impuesto &&
            ar.descripcionFactura === ret.descripcionFactura
          );

          cuentasCliente += round2Decimals(ret.totalRetenciones);

          if (idx > -1) {
            arrayRetencionesGlobal[idx].totalRetenciones = round2Decimals(arrayRetencionesGlobal[idx].totalRetenciones + ret.totalRetenciones);
            arrayRetencionesGlobal[idx].baseRetencion = round2Decimals(arrayRetencionesGlobal[idx].baseRetencion + ret.baseRetencion);
          } else {
            arrayRetencionesGlobal.push({
              tasaCuota: ret.tasaCuota,
              impuesto: ret.impuesto,
              montoRetencion: ret.montoRetencion,
              baseRetencion: ret.baseRetencion,
              descripcionFactura: ret.descripcionFactura,
              totalRetenciones: ret.totalRetenciones,
            });
          }
        });
      }
    });


    // Guardamos el array formateado en el estado
    this.setState({
      showPaymentModal: true,
      numeroVentaCobrar: null,
      cobroVenta: false,
      totalPagarCobroVenta: 0,
      ventaIdParaCobro: null,
      ventaIdParaFacturar: null,
      numeroVentaFacturar: null,
      productosParaTicket: insumos,
      arrayImpuestosVenta: arrayImpuestosGlobal,
      arrayRetencionesVenta: arrayRetencionesGlobal,
      cuentasCliente: cuentasCliente
    });
  };


  handlePaymentConfirm = (paymentData) => {
    Modal.success({
      title: 'Venta Completada',
      zIndex: 10000,
      content: (
        <div>
          <p><strong>Cliente:</strong> {paymentData.customer}</p>
          <p><strong>Total:</strong> {dineroDisabledMask(paymentData.totalPagar)}</p>
          <p><strong>Pagado:</strong> {dineroDisabledMask(paymentData.amountPaid)}</p>
          <p><strong>Cambio:</strong> {dineroDisabledMask(paymentData.change)}</p>
        </div>
      ),
      onOk: () => {
        // Si estamos en una venta guardada, eliminarla después del pago
        if (this.state.activeTab !== 'current') {
          this.removeSavedSale(this.state.activeTab);
        } else {
          this.clearCart();
        }
        this.setState({
          showPaymentModal: false,
          numeroVentaCobrar: null,
          cobroVenta: false,
          recargarVentas: true,
          totalPagarCobroVenta: 0,
          ventaIdParaCobro: null,
          ventaIdParaFacturar: null,
          numeroVentaFacturar: null,
          productosParaTicket: [], // Limpiar los productos del ticket
          arrayImpuestosVenta: [],
          arrayRetencionesVenta: [],
          cuentasCliente: 0,
          totalCalculations: null,
          clienteSeleccionadoId: this.state.clienteId || null,
          totalBreakdown: {
            subtotal: 0,
            totalImpuestos: 0,
            totalRetenciones: 0,
            total: 0,
            totalPagar: 0,
            arrayImpuestos: [],
            arrayRetenciones: [],
          }

        });
      }
    });
  };

  handlePaymentConfirmCobro = (paymentData) => {
    Modal.success({
      title: 'Venta Completada',
      zIndex: 10000,
      content: (
        <div>
          <p><strong>Cliente:</strong> {paymentData.customer}</p>
          <p><strong>Total:</strong> {dineroDisabledMask(paymentData.totalPagar)}</p>
          <p><strong>Pagado:</strong> {dineroDisabledMask(paymentData.amountPaid)}</p>
          <p><strong>Cambio:</strong> {dineroDisabledMask(paymentData.change)}</p>
        </div>
      ),
      onOk: () => {
        // Si estamos en una venta guardada, eliminarla después del pago
        if (this.state.activeTab !== 'current') {
          this.removeSavedSale(this.state.activeTab);
        } else {
          this.clearCart();
        }
        this.setState({
          showPaymentModal: false,
          numeroVentaCobrar: null,
          cobroVenta: false,
          recargarVentas: true,
          totalPagarCobroVenta: 0,
          ventaIdParaCobro: null,
          ventaIdParaFacturar: null,
          numeroVentaFacturar: null,
        });
      }
    });
  };

  generateCalculationKey = (productId, quantity, discount, clienteId) => {
    return `${productId}_${quantity}_${discount}_${clienteId || 'no_client'}`;
  };

  // 3. Función para calcular y cachear los impuestos de un producto
  calculateAndCacheProductTaxes = (product, quantity, discount = 0, clienteId = null) => {
    const key = this.generateCalculationKey(product.id, quantity, discount, clienteId);
    const currentSale = this.getCurrentSale();

    // Verificar si ya tenemos el cálculo cacheado
    if (currentSale.cartCalculations && currentSale.cartCalculations[key]) {
      return currentSale.cartCalculations[key];
    }

    // Calcular impuestos
    const calculation = this.calcularImpuestosYRetenciones(product, quantity, discount);

    // Guardar en cache
    const updatedCalculations = {
      ...currentSale.cartCalculations,
      [key]: {
        ...calculation,
        timestamp: Date.now(),
        productId: product.id,
        quantity,
        discount,
        clienteId
      }
    };

    this.updateCurrentSale({ cartCalculations: updatedCalculations });

    return calculation;
  };

  getProductCalculationFromCache = (productId, quantity, discount, clienteId) => {
    const key = this.generateCalculationKey(productId, quantity, discount, clienteId);
    const currentSale = this.getCurrentSale();

    if (currentSale.cartCalculations && currentSale.cartCalculations[key]) {
      return currentSale.cartCalculations[key];
    }

    return null;
  };

  clearCalculationCache = () => {
    this.updateCurrentSale({
      cartCalculations: {},
      totalCalculations: null
    });
  };

  handleDiscountChange = (discount) => {
    const cart = this.getCurrentCart();

    // Recalcular todos los productos con el nuevo descuento
    const updatedCart = cart.map(item => {
      const calculoImpuestos = this.calcularImpuestosYRetenciones(item, item.quantity, discount || 0);
      return {
        ...item,
        subtotal: calculoImpuestos.subtotal,
        totalImpuestos: calculoImpuestos.totalImpuestos,
        totalRetenciones: calculoImpuestos.totalRetenciones,
        total: calculoImpuestos.total
      };
    });

    // Limpiar cache cuando cambia el descuento
    this.updateCurrentSale({
      cart: updatedCart,
      discount: discount || 0,
      cartCalculations: {},
      totalCalculations: null
    });

    // Forzar recálculo completo
    setTimeout(() => {
      this.calculateTotalPagar();
    }, 10);
  };

  handleClienteChange = async (clienteId, clienteEncontrado) => {
      let cliente = clienteEncontrado;
      if (!cliente) {
        cliente = this.state.todasClientes.find(c => c._id === clienteId);
      }

      // Si el cliente no estaba en todasClientes, lo agregamos
      if (clienteEncontrado) {
          const yaExiste = this.state.todasClientes.find(i => i._id === clienteEncontrado._id);
          if (!yaExiste) {
            await this.setState(prev => ({ todasClientes: [...prev.todasClientes, clienteEncontrado] }));
          }
      }

      const cart = this.getCurrentCart();
      const precioViejo = this.getPrecioIdDinamico(); 
      const precioNuevo = this.getPrecioIdDinamico(clienteId); 

      if (precioViejo !== precioNuevo) {
        message.info('Se aplicó la lista de precios del cliente seleccionado.');
      }
      const { listaClienteActiva, precioId } = this.state;

      const updatedCart = cart.map(item => {
          // Lógica de precio idéntica a obtenerPrecioPorId
          let nuevoPrecioBase = precioId;
          
          if (listaClienteActiva && cliente?.precioContadoId) {
              nuevoPrecioBase = cliente.precioContadoId;
          }
          const precioEncontrado = item.insumoOriginal.precios?.find(p => p.precioId === nuevoPrecioBase);
          const price = precioEncontrado ? precioEncontrado.precio : item.insumoOriginal.costo;

          const itemActualizado = { ...item, price };
          const calculo = this.calcularImpuestosYRetenciones(itemActualizado, item.quantity, this.state.currentSale.discount || 0);

          return {
              ...itemActualizado,
              subtotal: calculo.subtotal,
              totalImpuestos: calculo.totalImpuestos,
              totalRetenciones: calculo.totalRetenciones,
              total: calculo.total
          };
      });

      this.updateCurrentSale({
          cart: updatedCart,
          clienteSeleccionadoId: clienteId,
          customer: cliente?.stringBuscar || '',
          cartCalculations: {},
          totalCalculations: null
      });

      setTimeout(() => this.calculateTotalPagar(), 50);
    };

  // 11. Modificar handleClienteChange para forzar recálculo
  /*handleClienteChange = async (clienteId, clienteEncontrado) => {
    
    const cart = this.getCurrentCart();
    const currentSale = this.getCurrentSale();
    
    let cliente
    if (clienteEncontrado) {
      cliente = clienteEncontrado;
      const yaExiste = this.state.todasClientes.find(i => i._id === cliente._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasClientes: [...prev.todasClientes, cliente]
        }));
      }
    } else {
      cliente = this.state.todasClientes.find(
        (valueClientes) => valueClientes._id === clienteId
      );
    }
    if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId || !cliente.usoDeCFDIID) {
      message.info('No se podra facturar a este cliente. Faltan datos')
    }
    if (!cliente.tipoClienteId) {
      const nombre = cliente.persona
      ? cliente.razonSocial
        : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
        this.abrirElegirTipoDeCliente(cliente._id, nombre);
      }
      
      // Recalcular todos los productos con el nuevo cliente
      const updatedCart = cart.map(item => {
        const calculoImpuestos = this.calcularImpuestosYRetenciones(item, item.quantity, currentSale.discount || 0);
        return {
        ...item,
        subtotal: calculoImpuestos.subtotal,
        totalImpuestos: calculoImpuestos.totalImpuestos,
        totalRetenciones: calculoImpuestos.totalRetenciones,
        total: calculoImpuestos.total
      };
    });

    // Limpiar cache cuando cambia el cliente
    this.updateCurrentSale({
      cart: updatedCart,
      clienteSeleccionadoId: clienteId,
      customer: clienteEncontrado ? clienteEncontrado.stringBuscar : '',
      cartCalculations: {},
      totalCalculations: null
    });

    // Forzar recálculo completo
    setTimeout(() => {
      this.calculateTotalPagar();
    }, 10);
  };*/

  calcularPrecioConImpuestos = (product) => {
    const { tipoDeCambio } = this.state;
    const precioBase = Number(product.price);

    // Si no hay impuestos, retornar precio base
    if (!product.insumoOriginal.impuestos || product.insumoOriginal.impuestos.length === 0) {
      return precioBase;
    }

    let totalImpuestos = 0;

    product.insumoOriginal.impuestos.forEach((impuesto) => {
      let impuestoCalculado = 0;

      if (impuesto.tasaCuota === 1) {
        // Porcentaje sobre el valor
        impuestoCalculado = precioBase * (impuesto.monto / 100);
      } else if (impuesto.tasaCuota === 2) {
        // Porcentaje sobre el valor más otros impuestos
        impuestoCalculado = (precioBase + totalImpuestos) * (impuesto.monto / 100);
      } else if (impuesto.tasaCuota === 3) {
        // Cuota por unidad
        impuestoCalculado = impuesto.monto / tipoDeCambio;
      } else if (impuesto.tasaCuota === 5) {
        // Exento
        impuestoCalculado = 0;
      }

      totalImpuestos += impuestoCalculado;
    });

    return round2Decimals(precioBase + totalImpuestos);
  };


  getSelectedProductsColumns = () => [
    {
      title: 'Producto',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{text}</div>
          <Text type="secondary" style={{ fontSize: '11px' }}>Código: {record.barcode}</Text>
        </div>
      )
    },
    {
      title: 'Precio Unit.',
      dataIndex: 'price',
      key: 'price',
      render: (price, record) => {
        const precioConImpuestos = this.calcularPrecioConImpuestos(record);
        return (
          <div>
            <Text strong style={{ color: '#52c41a', fontSize: '12px' }}>
              {dineroDisabledMask(precioConImpuestos)}
            </Text>
            <div style={{ fontSize: '10px', color: '#999' }}>
              Base: {dineroDisabledMask(price)}
            </div>
          </div>
        );
      }
    },
    {
      title: 'Cant.',
      key: 'quantity',
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            icon={<MinusOutlined />}
            onClick={() => this.updateQuantity(record.id, record.quantity - 1)}
            style={{ backgroundColor: '#00b5e2', borderColor: '#00b5e2', color: 'white' }}
          />
          <InputNumber
            min={1}
            max={record.inventariable ? record.stock : undefined}
            value={record.quantity}
            onChange={(value) => this.updateQuantity(record.id, value)}
            style={{ width: '60px' }}
          />
          <Button
            size="small"
            icon={<PlusOutlined />}
            onClick={() => this.updateQuantity(record.id, record.quantity + 1)}
            style={{ backgroundColor: '#00b5e2', borderColor: '#00b5e2', color: 'white' }}
          />
        </Space>
      )
    },
    {
      title: 'Subtotal',
      key: 'subtotal',
      render: (_, record) => {
        return (
          <div>
            <Text strong style={{ color: '#E96827', fontSize: '12px' }}>
              {dineroDisabledMask(record.total)}
            </Text>
            <div style={{ fontSize: '10px', color: '#666' }}>
              Sin imp: {dineroDisabledMask(record.subtotal)}
            </div>
            <div style={{ fontSize: '10px', color: '#52c41a' }}>
              Imp: {dineroDisabledMask(record.totalImpuestos)}
            </div>
            <div style={{ fontSize: '10px', color: '#f5222d' }}>
              Ret: {dineroDisabledMask(record.totalRetenciones)}
            </div>
          </div>
        );
      }
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => 
         (
          <>
            {record.insumoOriginal?.lotesCaducidades && (
                <Button 
                  size="small" 
                  icon={record.lotes?.length > 0 ? <CheckOutlined /> : <WarningOutlined />}
                  style={{ 
                    backgroundColor: record.lotes?.length > 0 ? '#52c41a' : '#faad14', 
                    color: 'white', border: 'none', fontSize: '11px', fontWeight: 'bold'
                  }}
                  onClick={() => this.abrirElegirLotes(record.id, record.lotes, record.insumoOriginal._id, record.cantidad)}
                >
                  {record.lotes?.length > 0 ? "Lotes" : "Lotes"}
                </Button>
            )}
            <Button
              type="text"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => this.removeFromCart(record.id)}
            />

          </>
        )
      
    }
  ];
  abrirElegirTipoDeCliente(id, nombre) {
    this.setState({
      modalElegirTipoDeCliente: true,
      modalElegirTipoDeClienteId: id,
      modalElegirTipoDeClienteNombre: nombre,
    });
  }
  cerrarElegirTipoDeCliente(elegido) {
    if (!elegido) {
      this.updateCurrentSale({
        clienteSeleccionadoId: null,
      });
    }
    this.setState({
      modalElegirTipoDeCliente: false,
      modalElegirTipoDeClienteId: null,
      modalElegirTipoDeClienteNombre: null,
    });
  }

  abrirCorteCaja = () => {
    this.setState({ showCorteCajaModal: true, showDrawerMenu: false });
  };

  onConfirmarImpresora = (impresora) => {
    this.setState({ impresoraSeleccionada: impresora, modalElegirImpresora: false });
    message.success(`Impresora seleccionada: ${impresora}`);
  };

  abrirElegirImpresora = () => {
    this.setState({ modalElegirImpresora: true, showDrawerMenu: false });
  }

  abrirCobrarVenta = () => {
    this.setState({ modalCobrarVenta: true, showDrawerMenu: false, recargarVentas: false });
  }

  handleCobrarVenta = (venta) => {
    this.setState({
      showPaymentModal: true,
      cobroVenta: true,
      recargarVentas: false,
      totalPagarCobroVenta: round2Decimals(venta.totalPagar - (venta.totalPagado || 0)),
      ventaIdParaCobro: venta._id,
      numeroVentaCobrar: venta.numero,
      ventaIdParaFacturar: null,
      numeroVentaFacturar: null,
    });
  }

  handleFacturarVenta = (venta) => {
    this.setState({
      showFacturarVenta: true,
      recargarVentas: false,
      ventaIdParaFacturar: venta._id,
      numeroVentaFacturar: venta.numero,
      cobroVenta: false,
      ventaIdParaCobro: null,
      numeroVentaCobrar: null,
    });
  }

  abrirVentasPendientes = () => {
    this.setState({ modalVentasPendientes: true, recargarVentas: false });
  }

  abrirFacturarVenta = () => {
    this.setState({ modalFacturarVenta: true, showDrawerMenu: false, recargarVentas: false });
  }

  handleFacturacionConfirm = () => {
    this.setState({
      showPaymentModal: false,
      numeroVentaCobrar: null,
      cobroVenta: false,
      recargarVentas: true,
    });
  }

  abrirElegirLotes = (cartItemId, lotesActuales, insumoOriginalId, cantidad) => {
    if (!this.state.proyectoId) {
      return message.warning("La caja no tiene un proyecto asignado para buscar lotes");
    }
    this.setState({
      modalElegirLotes: true,
      modalElegirLotesId: cartItemId,
      modalElegirLotesLotes: lotesActuales || [],
      modalElegirLotesInsumoId: insumoOriginalId,
      modalElegirLotesCantidad: cantidad,
    });
  };

  cerrarElegirLotes = (lotesSeleccionados) => {
    if (lotesSeleccionados) {
      const cart = this.getCurrentCart();
      const updatedCart = cart.map(item => {
        if (item.id === this.state.modalElegirLotesId) {
          return { ...item, lotes: lotesSeleccionados };
        }
        return item;
      });

      this.updateCurrentSale({ cart: updatedCart });
    }

    this.setState({
      modalElegirLotes: false,
      modalElegirLotesId: null,
      modalElegirLotesLotes: [],
      modalElegirLotesInsumoId: null,
      modalElegirLotesCantidad: null,
    });
  };

  render() {
    const currentSale = this.getCurrentSale();
    const currentCart = this.getCurrentCart();
    if (this.state.puntoVentaActivo) {
      return (
        <Spin spinning={this.state.loading}>
          <Layout style={{ minHeight: '100vh' }}>
            <Sider width={400} style={{ backgroundColor: 'white' }}>
              <Card
                title={
                  <Space>
                    <Button
                      type="text"
                      icon={<MenuOutlined />}
                      onClick={this.abrirDrawerMenu}
                      style={{
                        color: '#00b5e2',
                        fontSize: '18px',
                        padding: '4px'
                      }}
                    />
                    <ButtonItem
                      onClick={this.abrirVentasPendientes}
                      size="small"
                      verde
                    >
                      Pendientes
                    </ButtonItem>
                    <ShoppingCartOutlined style={{ color: '#00b5e2' }} />
                    <span>{this.state.cajaNombre}</span>
                    <Badge count={currentCart.length} style={{ backgroundColor: '#00b5e2' }} />
                  </Space>
                }
                style={{ height: '100vh', overflow: 'auto' }}
                bodyStyle={{ padding: '16px' }}
              >
                <div style={{ marginBottom: '16px' }}>
                  {currentCart.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                      <ShoppingCartOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                      <div>Carrito vacío</div>
                    </div>
                  ) : (
                    <Card
                      style={{
                        backgroundColor: '#f9f9f9',
                        marginBottom: '16px',
                        border: '1px solid #e8e8e8'
                      }}
                      bodyStyle={{ padding: '12px' }}
                    >
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text style={{ fontSize: '14px' }}>
                            {currentCart.length} producto{currentCart.length !== 1 ? 's' : ''}
                          </Text>
                        </Col>
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#00b5e2', fontWeight: 'bold' }}>
                            {currentCart.reduce((sum, item) => sum + item.quantity, 0)} unidades
                          </Text>
                        </Col>
                      </Row>
                    </Card>
                  )}
                </div>

                <Divider />

                {/* Formulario de venta */}
                <div>
                  {/* Cliente */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                    <Text style={{ 
                      color: '#00b5e2', 
                      fontWeight: 'bold', 
                      fontSize: '13px',
                      backgroundColor: '#e6f7ff', 
                      padding: '4px 12px',
                      borderRadius: '6px',
                      border: '1px solid #91d5ff',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                    }}>
                      {this.obtenerNombreListaActual()}
                    </Text>
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Cliente</label>
                    <SelectClientesItem
                      empresaId={this.state.empresaId}
                      headersToken={this.props.headersToken}
                      value={currentSale.clienteSeleccionadoId}
                      onChange={this.handleClienteChange} // Usar la nueva función
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Cliente"
                      puntoVenta
                    />
                  </div>

                  {/* Codigo */}
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Codigo</label>
                    <Input
                      placeholder="Codigo de Barras"
                      value={currentSale.barcodeInput}
                      onChange={(e) => this.updateCurrentSale({ barcodeInput: e.target.value })}
                      onKeyDown={this.handleBarcodeInput}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Factura</label>
                    <Switch
                      checked={currentSale.factura}
                      onChange={(checked) => this.updateCurrentSale({ factura: checked })}
                    />
                  </div>

                  {/* Descuento */}
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Descuento (%)</label>
                    <InputNumber
                      min={0}
                      max={100}
                      value={currentSale.discount}
                      onChange={this.handleDiscountChange} // Usar la nueva función
                      style={{ width: '100%' }}
                      placeholder="0"
                    />
                  </div>

                  {/* Observaciones */}
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Observaciones</label>
                    <TextAreaItem
                      rows={3}
                      maxLength={500}
                      placeholder="Observaciones de la venta (opcional)"
                      value={currentSale.observaciones}
                      onChange={(e) => this.updateCurrentSale({ observaciones: e.target.value })}
                    />
                    <Checkbox
                      checked={currentSale.imprimirObservaciones}
                      onChange={(e) => this.updateCurrentSale({ imprimirObservaciones: e.target.checked })}
                      style={{ marginTop: '8px' }}
                    >
                      Imprimir en ticket
                    </Checkbox>
                  </div>

                  {/* Botón para abrir modal de productos */}
                  <div style={{ marginBottom: '16px' }}>
                    <Button
                      type="default"
                      icon={<AppstoreOutlined />}
                      onClick={() => this.setState({ showProductModal: true })}
                      style={{
                        width: '100%',
                        height: '40px',
                        backgroundColor: '#f0f2f5',
                        borderColor: '#00b5e2',
                        color: '#00b5e2'
                      }}
                    >
                      Ver Catálogo de Productos
                    </Button>
                  </div>

                  {/* Botón para guardar venta */}
                  <div style={{ marginBottom: '16px' }}>
                    <Button
                      type="default"
                      icon={<SaveOutlined />}
                      onClick={this.saveCurrentSale}
                      disabled={currentCart.length === 0}
                      style={{
                        width: '100%',
                        height: '40px',
                        backgroundColor: '#52c41a',
                        borderColor: '#52c41a',
                        color: 'white'
                      }}
                    >
                      Guardar Venta
                    </Button>
                  </div>

                  <Divider />

                  {/* Total */}
                  <Card
                    style={{
                      backgroundColor: '#C9D51D',
                      marginBottom: '16px',
                      border: 'none'
                    }}
                  >
                    <div style={{ marginBottom: '12px' }}>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#333' }}>
                            Subtotal:
                          </Text>
                        </Col>
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#333', fontWeight: 'bold' }}>
                            {dineroDisabledMask(currentSale.totalBreakdown?.subtotal || 0)}
                          </Text>
                        </Col>
                      </Row>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#52c41a' }}>
                            Impuestos:
                          </Text>
                        </Col>
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#52c41a', fontWeight: 'bold' }}>
                            {dineroDisabledMask(currentSale.totalBreakdown?.totalImpuestos || 0)}
                          </Text>
                        </Col>
                      </Row>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#f5222d' }}>
                            Retenciones:
                          </Text>
                        </Col>
                        <Col>
                          <Text style={{ fontSize: '14px', color: '#f5222d', fontWeight: 'bold' }}>
                            -{" " + dineroDisabledMask(currentSale.totalBreakdown?.totalRetenciones || 0)}
                          </Text>
                        </Col>
                      </Row>
                      <Divider style={{ margin: '8px 0' }} />
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Title level={4} style={{ margin: 0, color: '#333' }}>
                            Total:
                          </Title>
                        </Col>
                        <Col>
                          <Title level={3} style={{ margin: 0, color: '#E96827' }}>
                            {dineroDisabledMask(currentSale.totalBreakdown?.totalPagar)}
                          </Title>
                        </Col>
                      </Row>
                    </div>
                  </Card>

                  {/* Botones de acción */}
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <Button
                      type="primary"
                      size="large"
                      id="process-sale-button"
                      icon={<FileTextOutlined />}
                      onClick={this.processPayment}
                      disabled={currentCart.length === 0}
                      style={{
                        width: '100%',
                        backgroundColor: '#E96827',
                        borderColor: '#E96827',
                        height: '48px'
                      }}
                    >
                      Procesar Venta
                    </Button>

                    <Button
                      danger
                      icon={<ClearOutlined />}
                      onClick={this.clearCart}
                      disabled={currentCart.length === 0}
                      style={{ width: '100%' }}
                    >
                      Limpiar Carrito
                    </Button>
                  </Space>
                </div>
              </Card>
            </Sider>

            {/* Panel Principal - Pestañas de Ventas */}
            <Layout>
              <Content style={{ padding: '24px', backgroundColor: '#f0f2f5' }}>
                <Card
                  title={
                    <Title level={3} style={{ margin: 0, color: '#00b5e2' }}>
                      <ShoppingCartOutlined /> Ventas
                    </Title>
                  }
                  style={{ height: '100%' }}
                >
                  <Tabs
                    activeKey={this.state.activeTab}
                    onChange={this.onTabChange}
                    type="editable-card"
                    hideAdd
                    onEdit={(targetKey, action) => {
                      if (action === 'remove' && targetKey !== 'current') {
                        this.removeSavedSale(targetKey);
                      }
                    }}
                  >
                    {/* Pestaña de venta actual */}
                    <TabPane
                      tab={
                        <span>
                          <ShoppingCartOutlined />
                          Venta Actual
                          {this.state.currentSale.cart.length > 0 && (
                            <Badge
                              count={this.state.currentSale.cart.length}
                              style={{ backgroundColor: '#00b5e2', marginLeft: '8px' }}
                            />
                          )}
                        </span>
                      }
                      key="current"
                      closable={false}
                    >
                      {this.renderSaleContent(this.state.currentSale.cart)}
                    </TabPane>

                    {/* Pestañas de ventas guardadas */}
                    {this.state.savedSales.map(sale => (
                      <TabPane
                        tab={
                          <span>
                            <FolderOutlined />
                            {sale.name}
                            <Badge
                              count={sale.cart.length}
                              style={{ backgroundColor: '#52c41a', marginLeft: '8px' }}
                            />
                          </span>
                        }
                        key={sale.id}
                      >
                        {this.renderSaleContent(sale.cart)}
                      </TabPane>
                    ))}
                  </Tabs>
                </Card>
              </Content>
            </Layout>

            <Drawer
              title={
                <Space>
                  <CalculatorOutlined style={{ color: '#00b5e2' }} />
                  <span style={{ color: '#00b5e2', fontWeight: 'bold' }}>Opciones de Caja</span>
                </Space>
              }
              placement="left"
              onClose={this.cerrarDrawerMenu}
              visible={this.state.showDrawerMenu}
              width={320}
              bodyStyle={{ padding: '24px' }}
              headerStyle={{
                backgroundColor: '#f6ffed',
                borderBottom: '2px solid #00b5e2'
              }}
            >
              <Space direction="vertical" style={{ width: '100%' }} size="large">

                {/* Información de la Caja */}
                <Card
                  size="small"
                  style={{
                    backgroundColor: '#f0f2f5',
                    border: '1px solid #d9d9d9'
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <Text style={{ fontSize: '14px', color: '#666' }}>Caja Actual</Text>
                    <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#00b5e2', marginTop: '4px' }}>
                      {this.state.cajaNombre}
                    </div>
                  </div>
                </Card>

                <Divider style={{ margin: '8px 0' }} />

                {/* Botón Facturacion */}
                <Button
                  type="default"
                  size="large"
                  icon={<BookOutlined />}
                  onClick={this.abrirFacturarVenta}
                  naranja
                  style={{
                    width: '100%',
                    height: '56px',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    backgroundColor: '#856011ff',     // Naranja para facturar
                    borderColor: '#856011ff',
                    boxShadow: '0 2px 4px rgba(133,96,17,0.3)'
                  }}
                >
                  Facturar Venta
                </Button>

                {/* Botón Corte de Caja */}
                <Button
                  type="default"
                  size="large"
                  icon={<IconCurrencyDollar />}
                  onClick={this.abrirCobrarVenta}
                  style={{
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#28a745',     // Verde para cobrar
                    borderColor: '#28a745',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(40,167,69,0.3)'
                  }}
                >
                  Cobrar Venta
                </Button>

                {/* Botón Corte de Caja */}
                <Button
                  type="default"
                  size="large"
                  icon={<CalculatorOutlined />}
                  onClick={this.abrirCorteCaja}
                  style={{
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#00b5e2',
                    borderColor: '#00b5e2',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,181,226,0.3)'
                  }}
                >
                  Corte de Caja
                </Button>

                {/* Botón Retiro de Efectivo */}
                <Button
                  type="default"
                  size="large"
                  icon={<DollarOutlined />}
                  onClick={this.abrirIngresoCaja}
                  style={{
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#54b86dff',
                    borderColor: '#54b86dff',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(84,184,109,0.3)'
                  }}

                >
                  Ingreso de Efectivo
                </Button>

                {/* Botón Retiro de Efectivo */}
                <Button
                  type="default"
                  size="large"
                  icon={<DollarOutlined />}
                  onClick={this.abrirRetiroCaja}
                  style={{
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#faad14',
                    borderColor: '#faad14',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(250,173,20,0.3)'
                  }}

                >
                  Retiro de Efectivo
                </Button>

                {/* Botón Retiro de Efectivo */}
                <Button
                  type="default"
                  size="large"
                  icon={<DollarOutlined />}
                  onClick={this.abrirElegirImpresora}
                  style={{
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#ffffffff',
                    borderColor: '#3f3f3fff',
                    color: 'black',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(255, 255, 255, 0.3)'
                  }}

                >
                  Impresora
                </Button>

                <Divider style={{ margin: '16px 0' }} />

                {/* Información adicional */}
                <div style={{ textAlign: 'center', color: '#999', fontSize: '12px' }}>
                  <Text type="secondary">
                    Usa estas opciones para gestionar tu caja registradora de forma segura
                  </Text>
                </div>

              </Space>
            </Drawer>

            {/* Modal de Productos */}
            <CatalogoModal
              visible={this.state.showProductModal}
              products={this.state.products}
              onCancel={() => this.setState({ showProductModal: false })}
              onAddToCart={this.addToCart}
              precioId={this.getPrecioIdDinamico()}
              proyectoId={this.state.proyectoId}
              empresaId={this.state.empresaId}
              sesionId={this.props.match.params.id}
            />

            {/* Modal de Pago */}
            <ModalPago
              visible={this.state.showPaymentModal}
              cobroVenta={this.state.cobroVenta}
              onCancel={() => this.setState({
                showPaymentModal: false,
                numeroVentaCobrar: null,
                cobroVenta: false,
                totalPagarCobroVenta: 0,
                ventaIdParaCobro: null,
                ventaIdParaFacturar: null,
                numeroVentaFacturar: null,
                productosParaTicket: [],
                arrayImpuestosVenta: [],
                arrayRetencionesVenta: [],
                cuentasCliente: 0,
              })}
              onConfirm={this.handlePaymentConfirm}
              onConfirmCobro={this.handlePaymentConfirmCobro}
              totalPagar={this.state.totalPagarCobroVenta || currentSale.totalBreakdown?.totalPagar || 0}
              total={currentSale.totalBreakdown?.total || 0}
              subtotal={currentSale.totalBreakdown?.subtotal || 0}
              discount={currentSale.discount}
              customer={currentSale.customer}
              sesionId={this.props.match.params.id}
              empresaId={this.state.empresaId}
              insumos={this.state.productosParaTicket} // Cambiar de currentSale.cart a productosParaTicket
              ventaIdParaCobro={this.state.ventaIdParaCobro}
              proyectoId={this.state.proyectoId}
              precioId={this.state.precioId}
              clienteId={currentSale.clienteSeleccionadoId}
              bancoId={this.state.bancoId}
              formaDePagoId={this.state.formaDePagoId}
              arrayImpuestosVenta={this.state.arrayImpuestosVenta}
              arrayRetencionesVenta={this.state.arrayRetencionesVenta}
              cuentasCliente={this.state.cuentasCliente}
              factura={currentSale.factura}
              observaciones={currentSale.observaciones}
              imprimirObservaciones={currentSale.imprimirObservaciones}
              impresoraSeleccionada={this.state.impresoraSeleccionada}
              numeroVentaCobrar={this.state.numeroVentaCobrar}
            />

            <ModalCorteCaja
              visible={this.state.showCorteCajaModal}
              onCancel={() => this.setState({ showCorteCajaModal: false })}
              cajaNombre={this.state.cajaNombre}
              empresaId={this.state.empresaId}
              corteConfirmado={() => this.setState({ showCorteCajaModal: false, puntoVentaActivo: false })}
              headersToken={this.props.headersToken}
              sesionId={this.props.match.params.id}
              impresoraSeleccionada={this.state.impresoraSeleccionada}
            />

            <ElegirTipoDeCliente
              visible={this.state.modalElegirTipoDeCliente}
              id={this.state.modalElegirTipoDeClienteId}
              nombre={this.state.modalElegirTipoDeClienteNombre}
              cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
              zIndex={1200}
            />

            <ModalRetiroCaja
              visible={this.state.modalRetiroCaja}
              onCancel={() => this.setState({ modalRetiroCaja: false })}
              sesionId={this.props.match.params.id}
              empresaId={this.state.empresaId}
            />

            <ModalIngresoCaja
              visible={this.state.modalIngresoCaja}
              onCancel={() => this.setState({ modalIngresoCaja: false })}
              sesionId={this.props.match.params.id}
              empresaId={this.state.empresaId}
            />

            <ModalElegirImpresora
              visible={this.state.modalElegirImpresora}
              onCancel={() => this.setState({ modalElegirImpresora: false, loading: false })}
              onConfirmarImpresora={this.onConfirmarImpresora}
              impresoraSeleccionada={this.state.impresoraSeleccionada}
            />

            {/* Modal de Ventas para Cobrar */}
            <ModalCobrarVenta
              visible={this.state.modalCobrarVenta}
              recargarVentas={this.state.recargarVentas}
              onCancel={() => this.setState({ modalCobrarVenta: false })}
              handleCobrarVenta={(venta) => this.handleCobrarVenta(venta)}
              empresaId={this.state.empresaId}
              sesionId={this.props.match.params.id}
            />

            {/* Modal de Ventas para Facturar */}
            <ModalFacturarVenta
              visible={this.state.modalFacturarVenta}
              recargarVentas={this.state.recargarVentas}
              onCancel={() => this.setState({ modalFacturarVenta: false })}
              handleFacturarVenta={(venta) => this.handleFacturarVenta(venta)}
              empresaId={this.state.empresaId}
              sesionId={this.props.match.params.id}
            />

            <ModalGenerarFactura
              visible={this.state.showFacturarVenta}
              onCancel={() => this.setState({ showFacturarVenta: false })}
              ventaId={this.state.ventaIdParaFacturar}
              empresaId={this.state.empresaId}
              headersToken={this.props.headersToken}
              sesionId={this.props.match.params.id}
              onConfirm={this.handleFacturacionConfirm}
              impresoraSeleccionada={this.state.impresoraSeleccionada}
              recargarVentas={this.state.recargarVentas}
            />

            <ModalVentasPendientes
              visible={this.state.modalVentasPendientes}
              onCancel={() => this.setState({ modalVentasPendientes: false })}
              ventaId={this.state.ventaIdParaFacturar}
              empresaId={this.state.empresaId}
              headersToken={this.props.headersToken}
              sesionId={this.props.match.params.id}
              handleFacturarVenta={(venta) => this.handleFacturarVenta(venta)}
              handleCobrarVenta={(venta) => this.handleCobrarVenta(venta)}
              impresoraSeleccionada={this.state.impresoraSeleccionada}
              recargarVentas={this.state.recargarVentas}
            />
            <ElegirLotes
              visible={this.state.modalElegirLotes}
              cerrarElegirLotes={this.cerrarElegirLotes}
              lotes={this.state.modalElegirLotesLotes}
              insumoId={this.state.modalElegirLotesInsumoId}
              proyectoId={this.state.proyectoId}
              clienteId={currentSale.clienteSeleccionadoId}
              cantidad={this.state.modalElegirLotesCantidad}
            />

          </Layout>
        </Spin>
      );
    } else {
      return (
        <Layout style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
          <Content style={{ padding: '24px', textAlign: 'center' }}>
            <Title level={3} style={{ color: '#00b5e2' }}>Punto de Venta Inactivo</Title>
            <Text type="secondary" style={{ fontSize: '16px' }}>
              Por favor, activa el punto de venta para comenzar a procesar ventas.
            </Text>
          </Content>
        </Layout>
      );
    }
  }

  renderSaleContent = (cart) => {
    if (cart.length === 0) {
      return (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: '#999',
          minHeight: '400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <ShoppingCartOutlined style={{ fontSize: '80px', marginBottom: '24px', color: '#d9d9d9' }} />
          <Title level={4} style={{ color: '#999', marginBottom: '16px' }}>
            No hay productos seleccionados
          </Title>
          <Text style={{ fontSize: '16px', marginBottom: '24px' }}>
            Usa el botón "Ver Catálogo de Productos" en el carrito para agregar productos
          </Text>
          <Button
            type="primary"
            icon={<AppstoreOutlined />}
            onClick={() => this.setState({ showProductModal: true })}
            style={{
              backgroundColor: '#00b5e2',
              borderColor: '#00b5e2',
              height: '40px',
              paddingLeft: '24px',
              paddingRight: '24px'
            }}
          >
            Ver Catálogo de Productos
          </Button>
        </div>
      );
    }

    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Text style={{ fontSize: '16px', color: '#666' }}>
            {cart.length} producto{cart.length !== 1 ? 's' : ''} en el carrito
          </Text>
        </div>
        <Table
          dataSource={cart}
          columns={this.getSelectedProductsColumns()}
          rowKey="id"
          pagination={{
            pageSize: 8,
            showSizeChanger: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} productos`
          }}
          scroll={{ y: 450 }}
        />
      </div>
    );
  };
}

// Mapeo del estado de Redux
const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(PuntoDeVentaPag);